export const XP_WINDOW_RESIZE_END = "xp-window-resize-end";
